module.exports = "mat-row{cursor:pointer !important}div.d-flex{width:100%}.table-sdw.is-fixed{margin-left:5px}\n"